export default {
  path: '/trace',
  name: 'trace',
  component: () => import('@/layouts/BaseLayout'),
  redirect: '/trace/batch',
  children: [
    {
      path: 'batch',
      meta: { title: '生码管理', permission: 'trace_batch' },
      component: () => import('@/views/trace/batch/index'),
    },
    {
      path: 'template',
      meta: { title: '展示模板', permission: 'trace_template' },
      component: () => import('@/views/trace/template/index'),
    },
    {
      path: 'code',
      meta: { title: '溯源码', permission: 'trace_code' },
      component: () => import('@/views/trace/code/index'),
    },
    {
      path: 'statistics',
      meta: { title: '扫码统计', permission: 'trace_statistic' },
      component: () => import('@/views/trace/statistics/index'),
    },
  ],
}
